import React from 'react';  
import PB from '../assets/pb.jpg'
import { motion } from "motion/react"
function CTA() { 
    return (
    <section id="cta"    className=" d-flex align-items-center ctapic" 
      style={{
        backgroundImage: `linear-gradient(
      180deg,
    rgba(0, 0, 0, 0.65),
      rgba(0, 0, 0, 0.65)
    ),url(${PB})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        maxHeight: "500px",
        width: "100%",
        borderTop: 'solid 2px white',
        borderBottom:'solid 2px white'
        // position: "relative",
        }}
       >
  <motion.div class="container text-center" initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{
    duration: 0.8,
    ease: "easeOut"
  }}
  viewport={{
    once: true,
    amount: 0.3
  }}>
    <h3 style={{fontFamily: 'Inter, sans-serif',fontSize:'clamp(1.0rem, 3vw, 3rem)', color:'white',fontWeight:'300', lineHeight:'1.1'}}>
    Invest in Nexora Systems and be part of an innovative technology company pursuing scalable growth, expanding opportunities, and long-term value.
    </h3>
   
          <a href="#" class="btn-ink rounded ctabtn" data-bs-toggle="" data-bs-target="" style={{ color: 'white', backgroundColor: 'transparent', fontWeight: '600', border: 'solid 2px white', boxShadow:'0px 6px 10px white' }}>
            
      Invest Now
    </a>
     {/* <div style={{marginTop:'32px', color:'rgba(13,13,13,45)', fontSize:'.72rem', letterSpacing:'.08em'}}>
      All information in this offering is for qualified accredited investors only. Securities not registered under the Securities Act.
    </div>  */}
  </motion.div>
</section>
)

}

export default CTA;